import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { SftpStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/sftp-store-read-settings';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SftpStoreReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        deleteFilesAfterCompletion: '*',
        disableChunking: '*'
    }
})
export class SftpStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    SftpStoreReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<SftpStoreReadSettings> {
        const model = await super._toModel(resource, copySource);
        ValueAdapter.toModel(
            model,
            SftpStoreReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );

        if (resource.disableChunking !== undefined) {
            ValueAdapter.toModel(model, SftpStoreReadSettings.DISABLE_CHUNKING, resource.disableChunking);
        } else {
            delete model.disableChunking;
        }
        return model;
    }

    protected override async _toResource(settings: SftpStoreReadSettings): Promise<Model.StoreReadSettings> {
        const resource = await super._toResource(settings);
        if (resource != null) {
            resource.deleteFilesAfterCompletion = ValueAdapter.toResource(
                settings,
                SftpStoreReadSettings.DELETE_FILE_AFTER_COMPLETION
            );
            resource.disableChunking = ValueAdapter.toResource(settings, SftpStoreReadSettings.DISABLE_CHUNKING);
        }
        return resource;
    }
}
